import { render, staticRenderFns } from "./ChannelSupplierCreditQuotaOrderEdit.vue?vue&type=template&id=6f5b54d3&"
import script from "./ChannelSupplierCreditQuotaOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./ChannelSupplierCreditQuotaOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelSupplierCreditQuotaOrderEdit.vue"
export default component.exports